module.exports = __webpack_public_path__ + "img/2024_CellSystems.194e3d75.png";